import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { usePageTitle, setDocumentTitle } from '../utils/translation'
import { PageHeader } from '../components/ui/PageHeader'
import { ReferralCodeCard } from '../components/ReferralCodeCard'
import { ReferralHistoryCard } from '../components/ReferralHistoryCard'
import useBottomNavPadding from '../hooks/useBottomNavPadding'
import { InfoIcon } from 'lucide-react'

export default function ReferralProgram() {
  const { t } = useTranslation()
  
  // Get translated page title
  const pageTitle = usePageTitle('account.sections.referralProgram', 'Referral Program')
  
  // Apply bottom padding for the navigation
  const bottomPadding = useBottomNavPadding()

  useEffect(() => {
    // Set the document title
    setDocumentTitle(pageTitle)
  }, [pageTitle])

  return (
    <main className="min-h-screen bg-gray-50">
      {/* Header */}
      <PageHeader
        title={t('account.sections.referralProgram')}
        backPath="/me"
      />

      {/* Main Content */}
      <div className={`max-w-2xl mx-auto p-4 space-y-6 pb-24 ${bottomPadding}`}>
        {/* Referral Code Section */}
        <ReferralCodeCard />
        
        {/* Program Description */}
        <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
          <div className="flex items-start space-x-3">
            <InfoIcon className="text-blue-500 w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="text-gray-600">
              {t('account.referral.description')}
            </div>
          </div>
        </div>
        
        {/* Referral History Section */}
        <ReferralHistoryCard />
      </div>
    </main>
  )
} 